import { render, staticRenderFns } from "./blindprize.vue?vue&type=template&id=d62bf5ec&scoped=true&"
import script from "./blindprize.vue?vue&type=script&lang=js&"
export * from "./blindprize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62bf5ec",
  null
  
)

export default component.exports